import { DefaultService } from '@/services/DefaultService';

export default class AtendimentocheckService extends DefaultService {
    constructor(http, router, env) {
        super(http, router, env);
    }

    findAllByLpsData(filters) {
        return this._http
            .post(
                encodeURI(`${this._env}/promotor/atendimentocheck/by-lps-data.json`),
                filters,
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }
}
